import React from 'react';
import { TransitionWrapper } from '../Helpers/transitionWrapper';
import { getLabel } from '../Language/labels';
import { setCurrentPage } from '../Navigation/currentPage';
import { setCompetitionTab } from '../Navigation/currentTab';
import { TAB_CATEGORIES, SCR_COMPETITION } from '../enums';

export const ProfileUpdated = ({ dispatch }) => {

  const navigateToCompetitionTab = () => {
    dispatch(setCompetitionTab(TAB_CATEGORIES));
    dispatch(setCurrentPage(SCR_COMPETITION));
  }

  return (
    <TransitionWrapper>
      <div className='profile-form-container'>
        <h1 className="overview-title">{getLabel('profileScreenTitle')}</h1>
        <div className="form">
          <h1 className='overview-title profile-status'>{getLabel('profileUpdated')}</h1>
          <div className='entry-status-back'>
            <button type='button' onClick={navigateToCompetitionTab} className='form-submit'>{getLabel('backToCompetition')}</button>
          </div>
        </div>
      </div>
    </TransitionWrapper>
  )
}

